import { extendTheme } from '@chakra-ui/react';
import components from './components';
import breakpoints from './foundations/breakpoints';
import borderRadius from './foundations/borderRadius';
import { ThemeColors as colors } from './foundations/colors';
import fonts from './foundations/fonts';
import fontSizes from './foundations/fontSizes';
import lineHeights from './foundations/lineHeights';
import space from './foundations/space';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
const config = {
    cssVarPrefix: 'booking-engine',
    initialColorMode: 'light',
    useSystemColorMode: false,
};
const baseTheme = Object.assign(Object.assign({}, borderRadius), { breakpoints,
    colors,
    components,
    config,
    fontSizes,
    fonts,
    lineHeights, sizes: Object.assign({}, space), space });
const theme = extendTheme(baseTheme);
const COLORS = [
    'black',
    'error',
    'neutral',
    'primary',
    'primaryContrast',
    'success',
    'warning',
    'white',
];
const COLOR_SHADES = [100, 200, 300, 400, 500, 600, 700, 800, 900];
export const getCssThemeColorVariable = (color = 'neutral.900') => {
    if (['black', 'white'].includes(color)) {
        return `--${config.cssVarPrefix}-colors-${color}-${50}`;
    }
    const [name = 'neutral', shade = '500'] = color.split('.');
    return `--${config.cssVarPrefix}-colors-${name}-${shade}`;
};
export default theme;
